import { CarGrid } from '../../../components/CarCards/CarGrid'
import { CarList } from '../../../components/CarCards/CarList'
import { ItemsCarousel } from '../../../components/ItemsCarousel'
import { ReadSearchTipsLink } from '../ReadSearchTipsLink'

const Items = ({
  viewOption,
  items,
  premiumCars,
  currency,
  closeGarageModal,
  openGarageModal,
  garageModalIsOpen,
  showCarousel,
  modal,
  loading,
  error,
}) => {
  if (!loading && error) {
    return (
      <div className="text-center">
        <p className="h3">Ooops, something went wrong.</p>
        <p className="text-muted">
          {'Try again later or report it to '}
          <a href="mailto:support@dyler.com">support@dyler.com</a>
        </p>
      </div>
    )
  }

  if (!loading && !error && items.length === 0) {
    return (
      <div className="text-center">
        <h3>{I18n.t('no_results')}</h3>
        <p className="text-muted">
          {I18n.t('cars.index.remove_filters')}
          {' / '}
          <ReadSearchTipsLink />
        </p>
        <a href={`/${I18n.t('routes.cars')}`}>
          <i className="fas fa-angle-double-left" /> {I18n.t('cars_for_sale')}
        </a>
      </div>
    )
  }

  if (viewOption === 'grid') {
    return (
      <div>
        {showCarousel && (
          <div>
            <ItemsCarousel
              cars={premiumCars}
              currency={currency}
              displayAddToGarageButton
              openGarageModal={openGarageModal}
              loading={loading}
            />
            <hr />
          </div>
        )}

        <CarGrid
          cars={items}
          currency={currency}
          displayAddToGarageButton
          openGarageModal={openGarageModal}
          loading={loading}
        />
      </div>
    )
  }

  if (viewOption === 'list') {
    return (
      <CarList
        items={items}
        currency={currency}
        closeGarageModal={closeGarageModal}
        openGarageModal={openGarageModal}
        modalIsOpen={garageModalIsOpen}
        loading={loading}
      />
    )
  }
}

export default Items
